import { render, staticRenderFns } from "./CoursesCreationPage.vue?vue&type=template&id=7b80a008&scoped=true&"
import script from "./CoursesCreationPage.vue?vue&type=script&lang=ts&"
export * from "./CoursesCreationPage.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesCreationPage.vue?vue&type=style&index=0&id=7b80a008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80a008",
  null
  
)

export default component.exports